import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, throwError, timeout, TimeoutError } from "rxjs";

import { NotificationService } from "./notification.service";

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
    private router = inject(Router);
    private notification = inject(NotificationService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Define o tempo de espera em milissegundos (30 minutos)
        const timeoutValue = 3600000;

        return next.handle(request).pipe(
            timeout(timeoutValue), // Define o tempo de espera
            catchError((error) => {
                let errorMessage = "";

                if (error instanceof HttpErrorResponse) {
                    if (error.status === 401) {
                        this.router.navigate(["/login"], {
                            queryParams: { returnUrl: this.router.url }
                        });
                    }
                    if (error.status === 403) {
                        this.router.navigate(["/not-authorized"]);
                    }
                    this.notification.serviceError(error);
                } else if (error instanceof TimeoutError) {
                    this.notification.info("general.messages.error504", true);
                } else {
                    if (error.error instanceof ErrorEvent) {
                        this.notification.error(error.error.message);
                    } else {
                        this.notification.error(error.message);
                    }
                }

                return throwError(() => errorMessage);
            })
        );
    }
}
